















































































































import { Component, Vue } from 'vue-property-decorator'
import { vxm } from '@/store/'
import SortIcons from '@/components/common/SortIcons.vue'
import PrvTableRow from '@/components/providers/PrvTableRow.vue'

const numeral = require('numeral')

@Component({
  components: {
    SortIcons,
    PrvTableRow
  }
})
export default class Providers extends Vue {
  // data
  private numeral = numeral
  currentSort = 'balance'
  currentSortDir = 'desc'

  // computed
  get sortedProviders() {
    let array = vxm.dappservices.dspRanking
    return array.sort((a: any, b: any) => {
      let aa = a[this.currentSort]
      let bb = b[this.currentSort]
      if (this.currentSort === 'packages' || this.currentSort === 'services') {
        aa = aa.length
        bb = bb.length
      }
      let modifier = 1
      if (this.currentSortDir === 'desc') modifier = -1
      if (aa < bb) return -1 * modifier
      if (aa > bb) return 1 * modifier
      return 0
    })
  }

  // methods
  sort(s: string) {
    if (s === this.currentSort) {
      this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc'
    }
    this.currentSort = s
  }

  // Lifecycle hooks
  mounted() {
    vxm.dappservices.getAccountTable()
  }
  created() {}
  updated() {}
  destroyed() {}
}
